import { useEffect, useState } from "react";

import {
  TextField, Typography, DatePicker, DocumentList,
  Modal, TextEditor, Checkbox
} from "@king-ict/eupisi-ui/components";
import { CodeBook } from "@king-ict/eupisi-ui/models";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

import { getAnnouncementById, deleteAnnouncement, getAnnouncementDocumentById } from "../../api/Announcement/AnnouncementApi";
import { ContentArea, FormCard, ToolbarEdit, ToolbarTop } from "../../components";
import { Role } from "../../models";
import { Announcement } from "../../models/Announcement";
import { FaqApplicationDisplay } from "../../models/Faq/Group";
import { Attachment } from "../../models/Shared/Attachment";
import { announcementEditUrl, announcementListRoute } from "../../routes/routes";

export function AnnouncementDetails() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();

  const createDefaultItem = (): Announcement => {
    return {
      id: 0,
      title: "",
      text: "",
      dateFrom: new Date(),
      status: true,
      isPortalVisible: false,
      isSticky: false,
      applicationDisplay: 1,
    };
  };
  const [item, setItem] = useState<Announcement>(createDefaultItem());
  const [roles] = useState<CodeBook[]>(() => {
    const arrayObjects = [] as CodeBook[];
    for (const [propertyKey, propertyValue] of Object.entries(Role)) {
      var num = Number(propertyKey);
      if (Number.isNaN(Number(propertyKey))) {
        continue;
      }
      var tranKey = "role." + propertyValue;
      var trans = t(tranKey);
      arrayObjects.push({ id: num, name: trans });
    }
    return arrayObjects;
  });
  const [showDeletedModal, setShowDeletedModal] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      if (!isNaN(+id) && +id > 0) {
        var result = (await getAnnouncementById(+id));
        if (result) {
          setItem(result);
        }
      }
    })();
  }, [id]);

  const goBack = () => {
    history.push(announcementListRoute);
  };
  const handleBackClicked = () => {
    goBack();
  };

  const handleEditClicked = () => {
    history.push(announcementEditUrl(+id));
  };
  const handleDeleteClicked = async () => {
    var result = await deleteAnnouncement(+id);
    if (result)
      setShowDeletedModal(true);
  };
  const handleGetDocument = (doc: Attachment) => {
    if (doc && doc.id) {
      getAnnouncementDocumentById(doc.id);
    }
  };
  const getRoleString = (a: Announcement): string | undefined => {
    var result = "";
    result += a.roleDisplay?.map((value, index) => {
      return roles.find((val => val.id === value))?.name;
    });
    return result !== "" ? result : undefined;
  };
  
  if (!item.text) return null;
  return (
    <ContentArea>
      <ToolbarTop
        showAdd={"hide"}
        showBack={"show"}
        showEdit={"show"}
        pageTitle={t("common.announcement.pageName")}
        onClickEdit={handleEditClicked}
        onClickBack={handleBackClicked}
      />
      <FormCard>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.announcement.title")}
              name={"item.title"}
              value={item.title}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextEditor
              label={t("common.announcement.text")}
              initialValue={item.text}
              handleChange={() => { }}
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <DatePicker
              label={t("common.announcement.dateFrom")}
              name={"item.dateFrom"}
              value={item.dateFrom}
              showTimePicker={true}
              readonly={true}
              plaintext={true}
              disabled
              className="mt-2"
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Checkbox
              label={t("common.announcement.isSticky")}
              plaintext={true}
              checked={item.isSticky}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.announcement.applicationDisplay")}
              name={"item.applicationDisplay"}
              value={t("common.faq.faqApplicationDisplay." + FaqApplicationDisplay[item.applicationDisplay]) as string}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.announcement.roleDisplay")}
              name={"item.roleDisplay"}
              value={getRoleString(item)}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              label={t("common.announcement.isPortalVisible")}
              plaintext={true}
              checked={item.isPortalVisible}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              label={t("common.announcement.active")}
              plaintext={true}
              checked={item.status}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Typography variant="medium" component="div" color="light">
              {t("common.announcement.attachments")}
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col>
            <DocumentList
              documents={item.attachments ?? []}
              removable={false}
              onDocumentClick={handleGetDocument}
            />
          </Col>
        </Row>
      </FormCard>
      <ToolbarEdit
        showDelete="show"
        onClickDelete={handleDeleteClicked}
      />
      <Modal
        type={"message"}
        confirmText={t("common.close")}
        open={showDeletedModal}
        onConfirm={() => goBack()}
        onClose={() => goBack()}
      >
        {t("common.deleteSuccess")}
      </Modal>
    </ContentArea>
  );
}


